import { useUser } from "@/requests/hooks/user";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useHasInitialLoadCompleted = () => {
  const { pathname } = useLocation();
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const { data: user } = useUser();

  useEffect(() => {
    if (!hasLoaded && !!user) debounce(setLocation, 2000)();
  }, [pathname]);

  const setLocation = () => setHasLoaded(true);

  const debounce = (callback: () => void, delay: number) => {
    let timer: NodeJS.Timeout;

    return () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        callback();
      }, delay);
    };
  };

  return hasLoaded;
};

export default useHasInitialLoadCompleted;
